import React, {useEffect, useLayoutEffect, useState} from 'react';
import {HistoryManager} from "../../managers/history-manager";
import {RouterController} from "./router-controller";
import {RouteModel} from "./models/route-model";
import {RouteComposer} from "./route-composer";
import {UseIoC} from "../composers/composer-plugins/use-ioc";
import {ErrorBoundaryWrapper} from "../error-boundary/error-boundary-wrapper";
import {useNavigate, useLocation, useNavigationType} from "react-router-dom";
import {AppStore} from "../../app/app-store";

export const RouterComposer = (Widget) => UseIoC()((props) => {
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const location = useLocation();
  const appStore: HistoryManager = props.ioc.getInstance(AppStore);
  const historyManager: HistoryManager = props.ioc.getInstance(HistoryManager);
  const routerController: RouterController = props.ioc.getInstance(RouterController);

  const resolveRouteComponent = (route: RouteModel): void => {
    !route.Component && (route.Component = RouteComposer(props, route));
  }

  const getRoutes: Array<RouteModel> = () => {
    const routes = routerController.getRoutes();

    routes.forEach((route: RouteModel) => resolveRouteComponent(route));

    return routes;
  }

  const getRedirects = () => {
    return routerController.getRedirects()
  }

  const [routes] = useState(getRoutes());
  const [redirectRoutes] = useState(getRedirects());

  useLayoutEffect(() => {
    if (!props.for) {
      historyManager.initHistory(navigate, location);

      if (appStore.state.settings.isWidget && navigationType === "POP") {
        historyManager.onPop();
      }
    }
  }, [navigate, historyManager, props.for]);

  useEffect(() => {
    if (historyManager.initialized) {
      historyManager.trackLocation(location);
    }
  }, [location, historyManager]);

  useEffect(() => {
    props?.onRouterLoaded?.();
  }, []);

  return (
    <ErrorBoundaryWrapper isMandatory>
      <React.Suspense fallback={<div/>}>
        <Widget  {...props} routes={routes} redirectRoutes={redirectRoutes} for={props.for}/>
      </React.Suspense>
    </ErrorBoundaryWrapper>
  );
});
